const r = typeof navigator < "u" && "locks" in navigator, e = (t, o, a = {}) => r ? (...n) => navigator.locks.request(t, a, async () => await o(...n)) : o;
export {
  r as navigatorLockSupported,
  e as withLock
};
